import { render, staticRenderFns } from "./winderStyle.vue?vue&type=template&id=67b67094&"
import script from "./winderStyle.vue?vue&type=script&lang=js&"
export * from "./winderStyle.vue?vue&type=script&lang=js&"
import style0 from "./winderStyle.vue?vue&type=style&index=0&id=67b67094&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports